import { api, desenvolver, tieneCodigo } from '../api';
import type { Cliente, GuardarClienteRequest } from '../api';

/**
 * La ficha de un receptor: nombre y domicilio (KAN-173).
 *
 * WSFE no lleva ninguno de los dos, así que la ficha es el único lugar donde
 * existen, y el PDF la lee al generarse. Vive en `/api/v1/clientes` y no en
 * `/admin`: **escribe**, y un operador tiene que poder fichar a quien le va a
 * facturar.
 */

/**
 * `PUT /api/v1/clientes`. Alta o actualización por `(tenant, docTipo, docNro)`:
 * mandar los mismos datos dos veces es inofensivo, y por eso el formulario de
 * emisión puede guardarla en cada intento sin averiguar antes si ya existe.
 */
export function guardarCliente(pedido: GuardarClienteRequest): Promise<Cliente> {
  return desenvolver(api.PUT('/api/v1/clientes', { body: pedido }));
}

/**
 * `GET /api/v1/clientes/{docTipo}/{docNro}`. **`null` si no hay ficha**: para
 * quien está por emitir eso no es un error sino el caso normal de un cliente
 * nuevo. Cualquier otra falla sí se lanza.
 */
export async function buscarCliente(datos: {
  tenantId: number;
  docTipo: Cliente['docTipo'];
  docNro: number;
}): Promise<Cliente | null> {
  try {
    return await desenvolver(
      api.GET('/api/v1/clientes/{docTipo}/{docNro}', {
        params: {
          path: { docTipo: datos.docTipo, docNro: datos.docNro },
          query: { tenantId: datos.tenantId },
        },
      }),
    );
  } catch (error) {
    if (tieneCodigo(error, 'no_encontrado')) {
      return null;
    }
    throw error;
  }
}
